import LayoutUser from '../layout/user/Layout.vue';

import PagePost from '../pages/PagePost.vue';
import PageLogin from '../pages/PageLogin.vue';
import PageHome from '../pages/PageHome.vue';
import PageSearch from '../pages/PageSearch.vue';
import PageNewPost from '../pages/PageNewPost.vue';
import PageSettings from '../pages/PageSettings.vue';
import PagePassword from '../pages/PagePassword.vue';
import PageEmail from '../pages/PageEmail.vue';
import PageSignup from '../pages/PageSignup.vue';
import PagePasswordReset from '../pages/PagePasswordReset.vue';
import PageForgot from '../pages/PageForgot.vue';
import PageUser from '../pages/PageUser.vue';
import PageBookmarks from '../pages/PageBookmarks.vue';
import PageLists from '../pages/PageLists.vue';
import PageList from '../pages/PageList.vue';
import PageMessages from '../pages/PageMessages.vue';
import PagePrice from '../pages/PagePrice.vue';
import PagePaymentSuccess from '../pages/PagePaymentSuccess.vue';
import PagePaymentFailure from '../pages/PagePaymentFailure.vue';
import PageSubscriptions from '../pages/PageSubscriptions.vue';
import PageNotifications from '../pages/PageNotifications.vue';
import PagePayouts from '../pages/PagePayouts.vue';
import PagePayments from '../pages/PagePayments.vue';
import PageContact from '../pages/PageContact.vue';
import PageCoin from '../pages/PageCoin.vue';
import PageEnableNotification from '../pages/PageEnableNotification.vue';
import PageIOSAddHomeButton from '../pages/PageIOSAddHomeButton.vue';
import AppSide from '../layout/AppSide.vue';

export default [
    {
        path: '/',
        component: LayoutUser,
        children: [
            {
                path: '/enable-notification',
                component: PageEnableNotification,
                name: 'enable-notification'
            },
            {
                path: '/ios-instruction',
                component: PageIOSAddHomeButton,
                name: 'ios-instruction'
            },
            {
                path: '/coin',
                component: PageCoin,
                name: 'coin'
            },
            {
                path: '/contact',
                component: PageContact
            },
            {
                path: '/payments/:attach?',
                component: PagePayments,
            },
            {
                path: '/payouts',
                component: PagePayouts,
            },
            {
                path: '/notifications',
                component: PageNotifications,
                name: 'notifications',
            },
            {
                path: '/subscriptions',
                component: PageSubscriptions,
                name: 'subscriptions',
            },
            {
                path: '/payment/failure',
                component: PagePaymentFailure
            },
            {
                path: '/payment/success/:gateway',
                component: PagePaymentSuccess
            },
            {
                path: '/messages/:id',
                component: PageMessages,
                name: 'message',
            },
            {
                path: '/messages',
                component: PageMessages,
                name: 'messages',
            },
            {
                path: '/lists',
                component: PageLists
            },
            {
                path: '/lists/:id',
                component: PageList,
                name: 'list'
            },
            {
                path: '/bookmarks',
                component: PageBookmarks
            },
            {
                path: '/forgot',
                components: {
                    default: PageForgot,
                    login: PageForgot
                }
            },
            {
                path: '/password-reset',
                components: {
                    default: PagePasswordReset,
                    login: PagePasswordReset
                }
            },
            {
                path: '/signup',
                components: {
                    default: PageSignup,
                    login: PageSignup
                }
            },
            {
                path: '/settings/price',
                component: PagePrice
            },
            {
                path: '/settings/email',
                component: PageEmail
            },
            {
                path: '/settings/password',
                component: PagePassword
            },
            {
                path: '/settings',
                component: PageSettings
            },
            {
                path: '/posts/create',
                component: PageNewPost
            },
            {
                path: '/posts/edit/:id',
                component: PageNewPost
            },
            {
                path: '/search',
                components: {
                    default: PageSearch,
                    side: AppSide
                },
                name: 'search'
            },
            {
                path: '/:username',
                component: PageUser,
                name: 'profile'
            },
            {
                path: '/:id/:username',
                component: PagePost,
            },
            {
                path: '/',
                components: {
                    default: PageHome,
                    login: PageLogin,
                    side: AppSide
                }
            },

        ]
    },
];